<template>
  <modal :show.sync="assignModal">
    <h4 slot="header" class="title title-up">
      {{ $t("app.modules.candidates.headers.assign_candidate") }}
    </h4>
    <ValidationObserver ref="formAdd" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitAssign)">
        <el-select
          class="select-primary"
          size="large"
          placeholder=""
          v-model="item.ejecutivoAsignado"
          filterable
        >
          <el-option
            v-for="user in usersList"
            class="select-primary"
            :value="user.idUsuario"
            :label="user.nombre"
            :key="user.idUsuario"
          >
          </el-option>
        </el-select>
        <div
          slot="footer"
          style="margin-top: 10px; padding-top: 20px;border-top: outset;"
          class="text-right"
        >
          <n-button class="pull-left" @click.native="cancelAssign()">{{
            $t("app.buttons.cancel")
          }}</n-button>
          <n-button native-type="submit" type="primary">{{
            $t("app.buttons.save")
          }}</n-button>
        </div>
      </form>
    </ValidationObserver>
  </modal>
</template>

<script>
export default {
  components: {},
  computed: {},
  data() {
    return {
      userSelected: 0,
      usersList: [],
      assignModal: false,
      item: { ejecutivoAsignado: 0 }
    };
  },
  methods: {},
  mounted() {
    EventBus.$on("prospectos-asignar", async item => {
      // Metodo para indicar al usuario que espere
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });

      await this.initAssign();
      this.$swal.close();
      console.log(item);
      this.item = item;
      if (this.item["ejecutivoAsignado"] == undefined) {
        this.item.ejecutivoAsignado = 0;
      }

      console.log(this.item);
      this.assignModal = true;
    });
  },
  methods: {
    async submitAssign() {
      if (this.item.ejecutivoAsignado > 0) {
        this.item.prospectoStatus = 2;
      } else {
        this.item.prospectoStatus = 1;
      }
      let payload = {
        id: 0,
        claveIdioma: "es",
        usuario: 0,
        prospecto: this.item
      };
      payload.prospecto.fechaEnvio = "2020-11-05T16:52:36.244Z";
      payload.prospecto.fechaAsignacion = "2020-11-05T16:52:36.244Z";
      await this.$http
        .put(route("Prospectos/asignarEjecutivo"), payload)
        .then(
          async response => {
            if (response.body.code === 200) {
              this.notifyMessage("success", this.$t("app.promps.save_success"));
              this.cancelAssign();
              EventBus.$emit("reload-items");
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
    },
    async initAssign() {
      var llama = {
        id: 55,
        rol: "ventas"
      };
      await this.$http
        .post(route("Usuarios/getUsuariosByRol"), llama)
        .then(
          async response => {
            if (response.body.code === 200) {
              this.usersList = response.body.usuariosRol;
              this.usersList.push({
                alias: "",
                correo: "",
                empresa_idEmpresa: 0,
                idRol: 0,
                idRolUsuario: 0,
                idUsuario: 0,
                nombre: this.$t("app.general.unassigned"),
                rol: "",
                rolActivo: true,
                usuarioActivo: true
              });
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
    },
    cancelAssign() {
      this.assignModal = false;
    }
  }
};
</script>
<style>
.form-group .el-input__inner {
  padding: 10px 18px 10px 30px !important;
}
</style>
